import React, { useState, useEffect } from 'react';

const SimpleOverview = ({ userInfo }) => {
  const [stats, setStats] = useState({
    totalSubaccounts: 0,
    activeConnections: 0,
    messagesToday: 0,
    qrCodesGenerated: 0,
    loading: true
  });

  useEffect(() => {
    if (userInfo?.agency?.id) {
      fetchStats();
    }
  }, [userInfo]);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const agencyId = userInfo?.agency?.id;
      
      if (!agencyId) return;

      const response = await fetch(`/agencies/${agencyId}/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setStats({
          totalSubaccounts: data.usage?.locations?.current || 0,
          activeConnections: data.stats?.connectedWhatsApp || 0,
          messagesToday: data.stats?.totalMessages || 0,
          qrCodesGenerated: data.stats?.qrCodesGenerated || 0,
          loading: false
        });
      }
    } catch (error) {
      console.error('Failed to fetch stats:', error);
      setStats(prev => ({ ...prev, loading: false }));
    }
  };

  return (
    <div className="py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="space-y-6">
          {/* Header */}
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Welcome back, {userInfo?.firstName || 'User'}!
            </h1>
            <p className="mt-1 text-sm text-gray-600">
              Here's what's happening with your WhatsApp integrations today.
            </p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl">🏢</span>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">Total Subaccounts</dt>
                      <dd className="text-lg font-medium text-gray-900">{stats.totalSubaccounts}</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl">✅</span>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">Active Connections</dt>
                      <dd className="text-lg font-medium text-gray-900">{stats.activeConnections}</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl">💬</span>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">Messages Today</dt>
                      <dd className="text-lg font-medium text-gray-900">{stats.messagesToday}</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white overflow-hidden shadow rounded-lg">
              <div className="p-5">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <span className="text-2xl">📱</span>
                  </div>
                  <div className="ml-5 w-0 flex-1">
                    <dl>
                      <dt className="text-sm font-medium text-gray-500 truncate">QR Codes Generated</dt>
                      <dd className="text-lg font-medium text-gray-900">{stats.qrCodesGenerated}</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="bg-white shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Quick Actions</h3>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
                <button
                  onClick={() => window.location.href = '/dashboard/subaccounts'}
                  className="bg-blue-500 hover:bg-blue-600 text-white p-4 rounded-lg shadow hover:shadow-md transition-all duration-200 text-left"
                >
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">➕</span>
                    <div>
                      <div className="font-medium">Add Subaccount</div>
                      <div className="text-sm opacity-90">Connect a new GHL location</div>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* Welcome Message */}
          <div className="bg-white shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Get Started</h3>
              <p className="text-gray-600 mb-4">
                Welcome to GOWa! To get started with WhatsApp integration:
              </p>
              <ol className="list-decimal list-inside space-y-2 text-gray-600">
                <li>Click "Add Subaccount" to add GOWa as your Conversation Provider.</li>
                <li>The WhatsApp QR code will be automatically added to the subaccount as a custom menu link.</li>
                <li>Select "WA (Custom)" as your custom Conversation Provider in the subaccount's Phone System.</li>
                <li>Scan the WhatsApp QR code from the custom menu link "Whatsapp sol".</li>
                <li>Start messaging your contacts — your messages will be sent directly via WhatsApp.</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleOverview;